import { useLocalStorage } from '@hooks/useLocalStorage'
import { useCallback } from 'react'
import { atom, useRecoilState } from 'recoil'

interface IsCommentDrawState {
	isCommentDraw: boolean
}

export const isCommentDrawState = atom<IsCommentDrawState>({
	key: '#isCommentDraw',
	default: {
		isCommentDraw: false,
	},
})

export const useIsCommentDrawControl = () => {
	const [state, setState] = useRecoilState(isCommentDrawState)
	const [localIsCommentDraw, setLocalIsCommentDraw] = useLocalStorage('comment_draw')

	const setIsCommentDraw = useCallback(
		(value?: boolean) => {
			if (value) {
				setState({ isCommentDraw: value })
				setLocalIsCommentDraw(`${value}`)
			} else {
				setState({ isCommentDraw: false })
				setLocalIsCommentDraw('false')
			}
		},
		[setState],
	)

	return { isCommentDraw: state.isCommentDraw, setIsCommentDraw }
}
